/**
 * 获取uuid
 */
export function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = 'id', pid = 'parentId') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]['children']) {
        temp[data[k][pid]]['children'] = []
      }
      if (!temp[data[k][pid]]['_level']) {
        temp[data[k][pid]]['_level'] = 1
      }
      data[k]['_level'] = temp[data[k][pid]]._level + 1
      temp[data[k][pid]]['children'].push(data[k])
    } else {
      res.push(data[k])
    }
  }
  return res
}

// 格式化日期 默认返回完整年月日时分秒，fmt：YYYY-MM-DD返回年月日，fmt: hh:mm:ss返回时分秒
export function formateTime(v = 0, fmt) {
  v = v / 1000
  let date = new Date(v * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-';
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
  let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  if (fmt == 'YYYY-MM-DD') {
    return Y + M + D;
  } else if (fmt == 'hh:mm:ss') {
    return h + m + s;
  } else {
    return Y + M + D + h + m + s;
  }
}

//对象深度克隆
export function cloneObj(obj) {
  var str, newobj = obj.constructor === Array ? [] : {};
  if (typeof obj !== 'object') {
    return;
  } else if (window.JSON) {
    str = JSON.stringify(obj), //序列化对象
      newobj = JSON.parse(str); //还原
  } else {
    for (var i in obj) {
      newobj[i] = typeof obj[i] === 'object' ? cloneObj(obj[i]) : obj[i];
    }
  }
  return newobj;
};

//行级鉴权
export function rowAuth(arr, authStr) {
  if (!arr) {
    return false
  }
  return arr.indexOf(authStr) != -1
}

//获取upload的文件列表
export function getUploadList(list) {
  let arr = [];
  for (let i = 0; i < list.length; i++) {
    let url = "";
    if (list[i].url) {
      url = list[i].url
    } else {
      if (list[i].response && list[i].response.data && list[i].response.data.entities && list[i].response.data.entities[0]) {
        url = list[i].response.data.entities[0]
      }
    }
    arr.push({
      name: list[i].name,
      url: url,
      size: list[i].size,
    })
  }
  return arr;
}

//使用post下载二进制流文件
export function postDownLoad(res, fileName) {
  const content = res
  const blob = new Blob([content])
  if ('download' in document.createElement('a')) { // 非IE下载
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  } else { // IE10+下载
    navigator.msSaveBlob(blob, fileName)
  }
}

// 格式化数字中文元角分
export function numberChinese(str) {
  var num = parseFloat(str);
  var strOutput = "",
    strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分';
  num += "00";
  var intPos = num.indexOf('.');
  if (intPos >= 0) {
    num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
  }
  strUnit = strUnit.substr(strUnit.length - num.length);
  for (var i = 0; i < num.length; i++) {
    strOutput += '零壹贰叁肆伍陆柒捌玖'.substr(num.substr(i, 1), 1) + strUnit.substr(i, 1);
  }
  return strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(
    /零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元")
}

/**
   * @desc 函数防抖
   * @param func 目标函数
   * @param wait 延迟执行毫秒数
   * @param immediate true - 立即执行， false - 延迟执行
   */
export function debounce(func, wait, immediate) {
  let timer;
  return function () {
    let context = this,
      args = arguments;

    if (timer) clearTimeout(timer);
    if (immediate) {
      let callNow = !timer;
      timer = setTimeout(() => {
        timer = null;
      }, wait);
      if (callNow) func.apply(context, args);
    } else {
      timer = setTimeout(() => {
        func.apply
      }, wait)
    }
  }
}

export function getFlexValueNameByCode(valueArray, value) {
  let result = "";
  if (valueArray) {
    valueArray.forEach((item, index) => {
      if (item.itemCode == value) {
        result = item.itemName;
      }
    })
  }
  return result
}

// ==================== OSS 相关工具函数 ====================

import axios from 'axios'
import Setting from '@/setting'
import { saveAs } from 'file-saver'

/**
 * 判断 URL 是否为 OSS 私有 bucket 文件（需要签名才能访问）
 * 通过后端 API 判断 URL 前缀与配置的 ossPath 是否一致
 * @param {string} url
 * @returns {Promise<boolean>}
 */
const ossUrlCheckCache = new Map()
export async function isOssUrl(url) {
  if (!url) return false
  // 检查缓存
  if (ossUrlCheckCache.has(url)) {
    const cached = ossUrlCheckCache.get(url)
    if (cached.expireAt > Date.now()) {
      return cached.value
    }
  }
  try {
    const { data } = await axios.get(Setting.apiBaseURL + '/basicdata/v1/oss/checkOssUrl', {
      params: { url }
    })
    if (data && data.code === 200 && data.success) {
      const isOss = data.result
      // 缓存结果 10 分钟
      const expireAt = Date.now() + 10 * 60 * 1000
      ossUrlCheckCache.set(url, { value: isOss, expireAt })
      return isOss
    }
  } catch (e) {
    console.error('检查 OSS URL 失败:', url, e)
  }
  // 降级：返回 false（非 OSS URL，走旧逻辑）
  return false
}

/**
 * OSS 签名 URL 缓存（避免重复请求）
 * key: 原始 URL + "_" + (forDownload ? "dl" : "pv"), value: { signedUrl, expireAt }
 */
const signedUrlCache = new Map()

function getSignedUrlCacheKey(ossUrl, forDownload) {
  return ossUrl + '_' + (forDownload ? 'dl' : 'pv')
}

/**
 * 获取 OSS 签名 URL
 * @param {string} ossUrl            - 完整的 OSS URL
 * @param {number} expirationSeconds - 过期时间（秒），默认 3600（1小时）
 * @param {boolean} forDownload      - 是否用于下载（true=attachment 强制下载，false=inline 预览）
 * @returns {Promise<string>} 带签名的 URL，失败返回原始 URL 作降级
 */
export async function getOssSignedUrl(ossUrl, expirationSeconds = 3600, forDownload = false) {
  if (!ossUrl || !(await isOssUrl(ossUrl))) {
    return ossUrl
  }
  // 检查缓存（预览和下载分别缓存）
  const cacheKey = getSignedUrlCacheKey(ossUrl, forDownload)
  const cached = signedUrlCache.get(cacheKey)
  if (cached && cached.expireAt > Date.now()) {
    return cached.signedUrl
  }
  try {
    const { data } = await axios.get(Setting.apiBaseURL + '/basicdata/v1/oss/getSignedUrl', {
      params: { ossUrl, expirationSeconds, forDownload }
    })
    if (data && data.code === 200 && data.success && data.result) {
      const signedUrl = data.result
      // 缓存签名 URL，提前 60 秒过期
      const expireAt = Date.now() + (expirationSeconds - 60) * 1000
      signedUrlCache.set(cacheKey, { signedUrl, expireAt })
      return signedUrl
    }
  } catch (e) {
    console.error('获取 OSS 签名 URL 失败:', ossUrl, e)
  }
  // 降级：返回原始 URL
  return ossUrl
}

/**
 * 使用 fetch + Blob 下载文件，避免直接跳转导致 PDF 等文件后缀变 .html
 * @param {string} url 已授权的文件地址（如 OSS 签名 URL）
 * @param {string} fileName 下载文件名
 */
export async function downloadFileByUrl(url, fileName) {
  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error('下载失败，HTTP ' + response.status)
    }
    const blob = await response.blob()
    const blobUrl = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = blobUrl
    a.download = fileName || url.substring(url.lastIndexOf('/') + 1).split('?')[0] || 'download'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(blobUrl)
  } catch (e) {
    // 降级：fetch 失败（如跨域）时回退到直接跳转
    console.error('Blob 下载失败，降级为直接跳转:', url, e)
    window.location.href = url
  }
}

/**
 * 下载文件（OSS 私有 bucket 需先做鉴权换取签名 URL，参考附件下载方式）：
 * - 是 OSS 文件：getOssSignedUrl(url, 3600, true) 换取授权下载链接，再 fetch + Blob 下载；
 * - 非 OSS 文件：直接 saveAs 下载。
 * @param {string} url 文件地址
 * @param {string} fileName 下载文件名（缺省时从 URL 提取）
 */
export async function downloadOssFile(url, fileName) {
  if (!url) return
  const name = fileName || url.split('/').pop()
  if (await isOssUrl(url)) {
    const signedUrl = await getOssSignedUrl(url, 3600, true)
    await downloadFileByUrl(signedUrl, name)
  } else {
    saveAs(url, name)
  }
}

/**
 * 批量获取 OSS 签名 URL
 * @param {string[]} ossUrls
 * @returns {Promise<string[]>} 签名后的 URL 列表
 */
export async function batchGetOssSignedUrl(ossUrls, expirationSeconds = 3600) {
  if (!ossUrls || !Array.isArray(ossUrls)) return ossUrls || []
  return Promise.all(ossUrls.map(url => getOssSignedUrl(url, expirationSeconds)))
}